import WithSidebar from 'layouts/WithSidebar';
import StepHandler from './components/StepHandler';

const AwardTickets = () => {
  return (
    <WithSidebar>
      <StepHandler />
    </WithSidebar>
  );
};

export default AwardTickets;
